<h1 class="page-title mb-5">قطاعات الاستثمار</h1>
<div>
  <div class="container-fluid">
    <div class="row">
      <div class="col-md-9">
        <div style="
            background-color: var(--color-gafi-border);
            border-right: 5px var(--color-primary) solid;
          " class="mb-4">
          <p style="font-size: 16px; color: var(--color-gray-444)" class="p-2">
            الهيئة العامة للاستثمار والمناطق الحرة هي هيئة اقتصادية عامة لها
            شخصية اعتبارية عامة تنظم الاستثمار في الدولة وتشجعه وتدعمه وتديره
            وتروج له بما يحقق خطة التنمية الاقتصادية للدولة ، ولها أن تنشئ
            فروعاً لها. أو مكاتب داخل جمهورية مصر العربية أو في الخارج بقرار من
            مجلس الإدارة كجزء من بعثات التمثيل التجاري. ​​
          </p>
        </div>

        <ul class="links-nav-cont p-0 m-0" id="pills-tab" role="tablist">
          <li class="links-nav">
            <a class="link-nav-href" [routerLink]="'/investments'" title=" الإتفاقات التجارية">
              <div class="img-wrapper">
                <img class="pill-img" src="../../../assets/department3.png"
                  onerror="this.src='assets/images/placeholder.jpg'" title=" الإتفاقات التجارية"
                  alt=" الإتفاقات التجارية" />
              </div>
              <span> الإتفاقات التجارية</span>
            </a>
          </li>
          <li class="links-nav">
            <a class="link-nav-href" [routerLink]="'/tradments'" title="القطاعات المستهدفة">
              <div class="img-wrapper">
                <img class="pill-img" src="../../../assets/department4.png"
                  onerror="this.src='assets/images/placeholder.jpg'" title="القطاعات المستهدفة "
                  alt="القطاعات المستهدفة " />
              </div>
              <span> القطاعات المستهدفة </span>
            </a>
          </li>
        </ul>
      </div>
      <div class="col-md-3">
        <app-fixed-sectors></app-fixed-sectors>
      </div>
    </div>
  </div>
</div>